export const useFeatureToggle = (toggleId: string): boolean => {
  return Boolean(window.__EXPERIMENTS__?.[toggleId]);
};
